export default __webpack_public_path__ + "static/all-in-one-7a4a615b555e162f9312891f19814f98.svg";